
import collect from 'collect.js'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      default() {
        return {
          sort: 'desc',
          sort_by: 'popular',
        }
      },
    },
  },
  computed: {
    sort: {
      get() {
        // return (this.$route.query.sort && this.$route.query.sort_by) ? this.$route.query.sort_by + '-' + this.$route.query.sort : 'popular-desc'
        return this.filter && this.filter.sort && this.filter.sort_by
          ? this.filter.sort_by + '-' + this.filter.sort
          : 'popular-desc'
      },
      set(newValue) {
        const data = Object.assign({}, this.$route.query)

        data.sort_by = newValue.split('-')[0]
        data.sort = newValue.split('-')[1]

        this.$router
          .replace({
            query: collect(data).filter().all(),
          })
          .catch(() => {})
      },
    },
  },
}
